import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const HeroEditor = () => {
  const [content, setContent] = useState({
    subtitle_ar: '',
    subtitle_en: '',
    title_ar: '',
    title_en: '',
    description_ar: '',
    description_en: '',
    cta_ar: '',
    cta_en: '',
    image_url: '',
    background_image_url: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/all`);
      const data = await response.json();
      if (data.success && data.data.hero) {
        setContent(data.data.hero);
      }
    } catch (error) {
      console.error('Error loading content:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setContent(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/hero`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(content)
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حفظ القسم الرئيسي بنجاح!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'خطأ في حفظ المحتوى');
      }
    } catch (error) {
      setMessage('خطأ في الاتصال');
      console.error('Save error:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleImageUpload = async (field, file) => {
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/upload/image`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();
      if (data.success) {
        const baseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net';
        const imageUrl = `${baseUrl}${data.url.startsWith('/') ? data.url : `/${data.url}`}`;
        handleChange(field, imageUrl);
        setMessage('تم رفع الصورة بنجاح!');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      console.error('Upload error:', error);
      setMessage('Image upload failed');
    }
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>محرر القسم الرئيسي</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>

      <div className="editor-grid">
        <div className="editor-column">
          <h3>المحتوى العربي</h3>
          <div className="editor-form-group">
            <label>العنوان الفرعي</label>
            <input
              type="text"
              value={content.subtitle_ar || ''}
              onChange={(e) => handleChange('subtitle_ar', e.target.value)}
            />
          </div>
          <div className="editor-form-group">
            <label>العنوان الرئيسي</label>
            <textarea
              rows="2"
              value={content.title_ar || ''}
              onChange={(e) => handleChange('title_ar', e.target.value)}
            />
          </div>
          <div className="editor-form-group">
            <label>الوصف</label>
            <textarea
              rows="4"
              value={content.description_ar || ''}
              onChange={(e) => handleChange('description_ar', e.target.value)}
            />
          </div>
          <div className="editor-form-group">
            <label>نص زر الدعوة</label>
            <input
              type="text"
              value={content.cta_ar || ''}
              onChange={(e) => handleChange('cta_ar', e.target.value)}
            />
          </div>
        </div>

        <div className="editor-column">
          <h3>المحتوى الإنجليزي</h3>
          <div className="editor-form-group">
            <label>Subtitle (English)</label>
            <input
              type="text"
              value={content.subtitle_en || ''}
              onChange={(e) => handleChange('subtitle_en', e.target.value)}
            />
          </div>
          <div className="editor-form-group">
            <label>Title (English)</label>
            <textarea
              rows="2"
              value={content.title_en || ''}
              onChange={(e) => handleChange('title_en', e.target.value)}
            />
          </div>
          <div className="editor-form-group">
            <label>Description (English)</label>
            <textarea
              rows="4"
              value={content.description_en || ''}
              onChange={(e) => handleChange('description_en', e.target.value)}
            />
          </div>
          <div className="editor-form-group">
            <label>CTA Button Text (English)</label>
            <input
              type="text"
              value={content.cta_en || ''}
              onChange={(e) => handleChange('cta_en', e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="editor-images-section">
        <div className="editor-form-group">
          <label>رابط صورة القسم الرئيسي</label>
          <div className="editor-image-input">
            <input
              type="text"
              value={content.image_url || ''}
              onChange={(e) => handleChange('image_url', e.target.value)}
              placeholder="رابط الصورة أو رفع ملف"
            />
            <label className="editor-upload-btn">
              رفع صورة
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageUpload('image_url', e.target.files[0])}
                style={{ display: 'none' }}
              />
            </label>
          </div>
          {content.image_url && (
            <img src={content.image_url} alt="Preview" className="editor-image-preview" />
          )}
        </div>

        <div className="editor-form-group">
          <label>رابط صورة الخلفية</label>
          <div className="editor-image-input">
            <input
              type="text"
              value={content.background_image_url || ''}
              onChange={(e) => handleChange('background_image_url', e.target.value)}
              placeholder="رابط الصورة أو رفع ملف"
            />
            <label className="editor-upload-btn">
              رفع صورة
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageUpload('background_image_url', e.target.files[0])}
                style={{ display: 'none' }}
              />
            </label>
          </div>
          {content.background_image_url && (
            <img src={content.background_image_url} alt="Preview" className="editor-image-preview" />
          )}
        </div>
      </div>

      <div className="editor-actions">
        <button
          className="editor-btn-save"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'جاري الحفظ...' : 'حفظ التغييرات'}
        </button>
      </div>
    </div>
  );
};

export default HeroEditor;

